var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "exit_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".exit_svg__st0{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 4.8c.7-.5 1.6-.4 2.1.3L20 10l-3.7 4.9c-.5.7-1.4.8-2.1.3-.7-.5-.8-1.4-.3-2.1l1.2-1.6H7.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h7.6l-1.2-1.6c-.5-.7-.3-1.6.3-2.1z",
    className: "exit_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5C1 2.6 2.6 1 4.5 1h4C10.4 1 12 2.6 12 4.5v1c0 .8-.7 1.5-1.5 1.5S9 6.3 9 5.5v-1c0-.3-.2-.5-.5-.5h-4c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5v-1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v1c0 1.9-1.6 3.5-3.5 3.5h-4C2.6 19 1 17.4 1 15.5v-11z",
    className: "exit_svg__st0"
  })));
};
export default SvgExit;